

export default [
	{
		path: '/request/fill/:id',
		name: 'RequestFill',
		component: () => import('../views/request/fill-view.vue'),
		meta: {
			title_key: ('router.requestFill'),
		},
	},
	{
		path: '/request/view/:id',
		name: 'RequestView',
		component: () => import('../views/request/view-view.vue'),
		meta: {
			title_key: ('router.requestView'),
		},
	},
	{
		path: '/request/list',
		name: 'RequestList',
		component: () => import('../views/request/list-view.vue'),
		meta: {
			title_key: ('router.requestList'),
		},
	},
	{
		path: '/offer/search/custom',
		name: 'OfferSearchCustom',
		component: () => import('../views/offer/search-view.vue'),
		meta: {
			title_key: ('router.offerSearchCustom'),
		},
	},
	{
		path: '/offer/search/request/:request',
		name: 'OfferSearchCloneRequest',
		component: () => import('../views/offer/search-view.vue'),
		meta: {
			title_key: ('router.offerSearchCloneRequest'),
		},
	},
	{
		path: '/offer/search/:menu',
		name: 'OfferSearch',
		component: () => import('../views/offer/search-view.vue'),
		meta: {
			title_key: ('router.offerSearch'),
		},
	},
	{
		path: '/offer/history/:species',
		name: 'OfferHistory',
		component: () => import('../views/offer/history-view.vue'),
		meta: {
			title_key: ('router.offerHistory'),
		},
	},
	{
		path: '/offer/sups-with-species/:species',
		name: 'SupsWithSpecies',
		component: () => import('../views/offer/sups-with-species-view.vue'),
		meta: {
			title_key: ('router.supsWithSpecies'),
		},
	},
	{
		path: '/messagecenter/list',
		name: 'MessageCenter',
		component: () => import('../views/message/center-view.vue'),
		meta: {
			title_key: ('router.messageCenter'),
		},
		children: [
			{
				path: 'detail/:id',
				name: 'MessageDetail',
				component: () => import('../views/message/conversation-view.vue'),
				meta: {
					title_key: ('router.messageDetail'),
				},
			},
		],
	},
	{
		path: '/offer/detail/:id',
		name: 'OfferDetail',
		component: () => import('../views/offer/detail-view.vue'),
		meta: {
			title_key: ('router.offerDetail'),
		},
	},
	{
		path: '/user/accept-invite',
		name: 'AcceptInvite',
		component: () => import('../views/user/invite.vue'),
		meta: {
			title_key: ('router.userInvite'),
		},
	},
	{
		path: '/user/profile/:tab?',
		name: 'UserProfile',
		component: () => import('../views/user/profile-view.vue'),
		meta: {
			title_key: ('router.userProfile'),
		},
	},
	{
		path: '/cms/edit-news',
		name: 'CmsEditNews',
		component: () => import('../views/cms/edit-news-view.vue'),
		meta: {
			title_key: ('router.cmsEditNews'),
		},
	},
	{
		path: '/cms/page/:id',
		name: 'CmsPage',
		component: () => import('../views/cms/page-view.vue'),
		meta: {
			title_key: ('router.cmsPage'),
		},
	},
	{
		path: '/linked-user/list',
		name: 'LinkedConsultantsList',
		component: () => import('../views/user/linked-consultant.vue'),
		meta: {
			title_key: ('router.linkedConsultantsList'),
		},
	},
	{
		path: '/self-register',
		name: 'RegisterAgrWithUploadedAccount',
		component: () => import('../components/registration/register-from-uploaded.vue'),
		meta: {
			title_key: ('router.registerAgrWithUploadedAccount'),
		},
	},
	{
		path: '/search-farmers',
		name: 'SearchFarmers',
		component: () => import('../views/user/search-farmers.vue'),
		meta: {
			title_key: ('router.searchFarmers'),
		},
	},
	{
		path: '/request-preview',
		name: 'RequestPreview',
		component: () => import('../views/request/preview-view.vue'),
		meta: {
			title_key: ('router.requestPreview'),
		},
	},
	{
		path: '/request/legacy/list',
		name: 'RequestArchiveList',
		component: () => import('../views/request/legacy-list-view.vue'),
		meta: {
			title_key: ('router.requestArchiveList'),
		},
	},
	{
		path: '/request/legacy/detail/:id',
		name: 'RequestArchiveDetail',
		component: () => import('../views/request/legacy-detail-view.vue'),
		meta: {
			title_key: ('router.requestArchiveDetail'),
		},
	},
	{
		path: '/cms/aut-statistics',
		name: 'RdbAutStatistics',
		component: () => import('../views/cms/rdb-aut-statistics.vue'),
		meta: {
			title_key: ('router.rdbAutStatistics'),
		},
	},
	{
		path: '/oxs/faq',
		name: 'OxsFaq',
		component: () => import('../views/cms/oxs-faq.vue'),
		meta: {
			title_key: ('router.oxsFaq'),
		},
	},
	{
		path: '/offer/search/prm/:menu/:sort/:lang',
		name: 'OfferSearchBio',
		component: () => import('../views/offer/search-view.vue'),
		meta: {
			title_key: ('router.offerSearchBio'),
		},
	},
	{
		path: '/user/import',
		name: 'AgrImport',
		component: () => import('../views/user/agr-import.vue'),
		meta: {
			title_key: ('router.userImport'),
		},
	},
	{
		path: '/request/detail-export',
		name: 'RequestDetailExport',
		component: () => import('../views/request/kom-report-view.vue'),
		meta: {
			title_key: ('components.menu.requestExport'),
		},
	},
];
